import { obtenerMensajeError } from "utils/apiErrors";
import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  Table,
  //TableHead,
  TableBody,
  TableRow,
  TableCell,
  Container,
  Typography,
  Box,
  Checkbox,
  InputLabel,
  IconButton,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import Grid from "@mui/material/Grid2";

import EditIcon from "@mui/icons-material/Edit";
import ClearIcon from "@mui/icons-material/Clear";

import SuiButton from "components/SuiButton";
import SuiTypography from "components/SuiTypography";

import { verificarEtapaAnterior } from "../utils/etapaHelpers";

import useUserRoles from "hooks/useUserRoles";

import SelectApoderado from "../components/SelectApoderado";
import ModalApoderado from "../components/SelectApoderado";
import ModalAcreedor from "./modalAcreedor";

import ProcesosApi from "api/procesosApi";

const ContainerQuorum = ({ proceso, audiencia: initialAudiencia, onAudienciaChange }) => {
  const { user, roles } = useUserRoles();
  const [asistencia, setAsistencia] = useState({});
  const [selectedAcreedorId, setSelectedAcreedorId] = useState(null);
  const [showAcreedorEditModal, setShowAcreedorEditModal] = useState(false);
  const [showApoderadoModal, setShowApoderadoModal] = useState(false);
  const [showAcreedorApoderadoModal, setShowAcreedorApoderadoModal] = useState(false);
  const [ordenActual] = useState(1);
  const [verificacion, setVerificacion] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (initialAudiencia) {
      fetchDatosIniciales();
      setVerificacion(verificarEtapaAnterior(initialAudiencia?.etapas, ordenActual));
    }
  }, [user, initialAudiencia, ordenActual]);

  const fetchDatosIniciales = async () => {
    try {
      setLoading(true);
      const etapaQuorum = initialAudiencia.etapas.find((etapa) => etapa.orden === 1);
      const participantes = etapaQuorum?.participantes || {};
      //console.log("participantes.acreedores: " + JSON.stringify(participantes.acreedores));
      const newAsistencia = {
        deudor: participantes.deudor || null,
        deudor_apoderado: participantes.deudor_apoderado || null,
        acreedores: participantes.acreedores || [],
      };
      setAsistencia(newAsistencia);
    } catch (error) {
      console.error("Error obteniendo los datos iniciales:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (field, index) => (event) => {
    const checked = event.target.checked;
    setAsistencia((prev) => {
      if (field === "deudor" || field === "deudor_apoderado") {
        return {
          ...prev,
          [field]: prev[field] ? { ...prev[field], asistio: checked } : null,
        };
      }
      // Para acreedores
      if (field === "acreedores") {
        const updatedList = prev[field]?.map((item, i) => {
          if (i === index) {
            const updatedItem = { ...item, asistio: checked };
            // Si tiene apoderado, sincronizar su asistencia
            if (item.apoderado) {
              updatedItem.apoderado = {
                ...item.apoderado,
                asistio: checked,
              };
            }
            return updatedItem;
          }
          return item;
        });
        return { ...prev, [field]: updatedList };
      }
      // Para otros campos (mantener lógica original)
      const updatedList = prev[field]?.map((item, i) =>
        i === index ? { ...item, asistio: checked } : item
      );
      return { ...prev, [field]: updatedList };
    });
  };

  const handleSave = async () => {
    const confirmacion = window.confirm(`¿Estás seguro(a) que deseas guardar la Etapa de Quorum?`);
    if (!confirmacion) return;
    try {
      setSaving(true);
      const updatedAudiencia = {
        ...initialAudiencia,
        estado: "REALIZADA",
        etapas: initialAudiencia.etapas.map((etapa) =>
          etapa.orden === ordenActual // QUORUM
            ? {
                ...etapa,
                estado: "CUMPLIDA",
                participantes: {
                  // Asegurar que los datos de asistencia estén actualizados
                  deudor: asistencia.deudor
                    ? {
                        ...asistencia.deudor,
                        asistio: asistencia.deudor.asistio || false,
                      }
                    : null,
                  deudor_apoderado: asistencia.deudor_apoderado
                    ? {
                        ...asistencia.deudor_apoderado,
                        asistio: asistencia.deudor_apoderado.asistio || false,
                      }
                    : null,
                  acreedores:
                    asistencia.acreedores?.map((acreedor) => ({
                      ...acreedor,
                      asistio: acreedor.asistio || false,
                      apoderado: acreedor.apoderado
                        ? {
                            ...acreedor.apoderado,
                            asistio: acreedor.apoderado.asistio || false,
                          }
                        : null,
                    })) || [],
                },
                resultado: {
                  resultado: "CUMPLIDA",
                  observacion_acta: null,
                },
              }
            : etapa
        ),
      };
      await ProcesosApi.actualizarAudiencia(initialAudiencia.id, updatedAudiencia);
      onAudienciaChange && onAudienciaChange(updatedAudiencia);
      fetchDatosIniciales();
    } catch (error) {
      console.error("Error al actualizar las deudas o la audiencia:", error);
    } finally {
      setSaving(false);
    }
  };

  const handleAbrirEtapa = async () => {
    const confirmAction = window.confirm(`¿Estás seguro(a) que deseas abrir la Etapa de Quorum?`);
    if (confirmAction) {
      try {
        setSaving(true);
        const updatedAudiencia = {
          ...initialAudiencia,
          etapas: initialAudiencia.etapas.map((etapa) => {
            if (etapa.orden === ordenActual) {
              return {
                ...etapa,
                estado: "PENDIENTE",
              };
            } else if (etapa.orden > ordenActual) {
              return {
                ...etapa,
                estado: "PROGRAMADA",
              };
            }
            return etapa;
          }),
        };
        await ProcesosApi.actualizarAudiencia(initialAudiencia.id, updatedAudiencia);
        onAudienciaChange && onAudienciaChange(updatedAudiencia);
        fetchDatosIniciales();
      } catch (error) {
        console.error("Error al abrir la Etapa", error);
      } finally {
        setSaving(false);
      }
    }
  };

  const handleApoderadoSelect = async (selectedApoderado) => {
    try {
      setSaving(true);
      // Actualizar el estado local
      setAsistencia((prev) => ({
        ...prev,
        deudor_apoderado: {
          ...selectedApoderado,
          asistio: false,
        },
      }));
      const updatedAudiencia = {
        ...initialAudiencia,
        etapas: initialAudiencia.etapas.map((etapa) => {
          if (etapa.orden === ordenActual) {
            return {
              ...etapa,
              participantes: {
                ...etapa.participantes,
                deudor_apoderado: {
                  ...selectedApoderado,
                  asistio: false,
                },
              },
            };
          }
          return etapa;
        }),
      };
      await ProcesosApi.actualizarAudiencia(initialAudiencia.id, updatedAudiencia);
      // Sincronizar el apoderado con el proceso
      await ProcesosApi.actualizarProceso(proceso.id, {
        apoderado: selectedApoderado.id,
      });
      onAudienciaChange && onAudienciaChange(updatedAudiencia);
      setShowApoderadoModal(false);
    } catch (error) {
      console.error("Error al asignar el apoderado:", error);
      alert(
        obtenerMensajeError(
          error,
          "Error al asignar el apoderado del deudor. Por favor, intenta nuevamente."
        )
      );
    } finally {
      setSaving(false);
    }
  };

  const handleRemoveApoderadoDeudor = async () => {
    if (!window.confirm("¿Está seguro que desea quitar el apoderado del deudor?")) {
      return;
    }
    try {
      setSaving(true);
      setAsistencia((prev) => ({
        ...prev,
        deudor_apoderado: null,
      }));
      const updatedAudiencia = {
        ...initialAudiencia,
        etapas: initialAudiencia.etapas.map((etapa) => {
          if (etapa.orden === ordenActual) {
            return {
              ...etapa,
              participantes: {
                ...etapa.participantes,
                deudor_apoderado: null,
              },
            };
          }
          return etapa;
        }),
      };
      await ProcesosApi.actualizarAudiencia(initialAudiencia.id, updatedAudiencia);
      // Sincronizar el apoderado con el proceso
      await ProcesosApi.actualizarProceso(proceso.id, {
        apoderado: null,
      });
      onAudienciaChange && onAudienciaChange(updatedAudiencia);
    } catch (error) {
      console.error("Error al quitar el apoderado:", error);
      alert(obtenerMensajeError(error, "Error al quitar el apoderado del deudor."));
    } finally {
      setSaving(false);
    }
  };

  const handleAcreedorApoderadoSelect = async (acreedorId, selectedApoderado) => {
    try {
      setSaving(true);
      // Actualizar el estado local
      setAsistencia((prev) => ({
        ...prev,
        acreedores: prev.acreedores.map((acreedor) => {
          if (acreedor.id === acreedorId) {
            return {
              ...acreedor,
              apoderado: {
                ...selectedApoderado,
                asistio: acreedor.asistio || false, // Sincronizar con la asistencia del acreedor
              },
            };
          }
          return acreedor;
        }),
      }));
      // Actualizar la audiencia en la base de datos
      const updatedAudiencia = {
        ...initialAudiencia,
        etapas: initialAudiencia.etapas.map((etapa) => {
          if (etapa.orden === ordenActual) {
            return {
              ...etapa,
              participantes: {
                ...etapa.participantes,
                acreedores: etapa.participantes.acreedores.map((acreedor) => {
                  if (acreedor.id === acreedorId) {
                    return {
                      ...acreedor,
                      apoderado: {
                        ...selectedApoderado,
                        asistio: acreedor.asistio || false, // Sincronizar con la asistencia del acreedor
                      },
                    };
                  }
                  return acreedor;
                }),
              },
            };
          }
          return etapa;
        }),
      };

      await ProcesosApi.actualizarAudiencia(initialAudiencia.id, updatedAudiencia);
      onAudienciaChange && onAudienciaChange(updatedAudiencia);
      setShowAcreedorApoderadoModal(false);
    } catch (error) {
      console.error("Error al asignar el apoderado al acreedor:", error);
      alert(
        obtenerMensajeError(
          error,
          "Error al asignar el apoderado del acreedor. Por favor, intenta nuevamente."
        )
      );
    } finally {
      setSaving(false);
    }
  };

  const handleRemoveAcreedorApoderado = async (acreedorId) => {
    if (!window.confirm("¿Está seguro que desea quitar el apoderado de este acreedor?")) {
      return;
    }
    try {
      setSaving(true);
      setAsistencia((prev) => ({
        ...prev,
        acreedores: prev.acreedores.map((acreedor) =>
          acreedor.id === acreedorId ? { ...acreedor, apoderado: null } : acreedor
        ),
      }));
      const updatedAudiencia = {
        ...initialAudiencia,
        etapas: initialAudiencia.etapas.map((etapa) => {
          if (etapa.orden === ordenActual) {
            return {
              ...etapa,
              participantes: {
                ...etapa.participantes,
                acreedores: etapa.participantes.acreedores.map((acreedor) =>
                  acreedor.id === acreedorId ? { ...acreedor, apoderado: null } : acreedor
                ),
              },
            };
          }
          return etapa;
        }),
      };
      await ProcesosApi.actualizarAudiencia(initialAudiencia.id, updatedAudiencia);
      onAudienciaChange && onAudienciaChange(updatedAudiencia);
    } catch (error) {
      console.error("Error al quitar el apoderado del acreedor:", error);
      alert(obtenerMensajeError(error, "Error al quitar el apoderado del acreedor."));
    } finally {
      setSaving(false);
    }
  };

  const isDisabled = () => {
    return (
      !verificacion ||
      initialAudiencia.estado === "SUSPENDIDA" ||
      initialAudiencia.estado === "CERRADA" ||
      (ordenActual > 1 && !verificacion.isQuorumCumplido) ||
      (ordenActual > 1 && !verificacion.isEtapaAnteriorCumplida) ||
      verificacion.estadoActual === "CUMPLIDA" ||
      saving // DESHABILITAR MIENTRAS SE GUARDA
    );
  };

  const isOpenEtapaDisabled = () => {
    return (
      !verificacion ||
      initialAudiencia.estado === "SUSPENDIDA" ||
      initialAudiencia.estado === "CERRADA" ||
      verificacion.isEtapaActualPendiente ||
      verificacion.isEtapaSiguienteCumplida ||
      saving // DESHABILITAR MIENTRAS SE GUARDA
    );
  };

  const handleSaveAcreedor = async (updatedAcreedor) => {
    try {
      setSaving(true);
      setAsistencia((prev) => ({
        ...prev,
        acreedores: prev.acreedores.map((a) =>
          a.id === selectedAcreedorId ? { ...a, ...updatedAcreedor } : a
        ),
      }));
      const updatedAudiencia = {
        ...initialAudiencia,
        etapas: initialAudiencia.etapas.map((etapa) => {
          if (etapa.orden === ordenActual) {
            return {
              ...etapa,
              participantes: {
                ...etapa.participantes,
                acreedores: etapa.participantes.acreedores.map((a) =>
                  a.id === selectedAcreedorId ? { ...a, ...updatedAcreedor } : a
                ),
              },
            };
          }
          return etapa;
        }),
      };
      await ProcesosApi.actualizarAudiencia(initialAudiencia.id, updatedAudiencia);
      onAudienciaChange && onAudienciaChange(updatedAudiencia);
      setShowAcreedorEditModal(false);
    } catch (error) {
      console.error("Error al actualizar el acreedor:", error);
      alert(obtenerMensajeError(error, "Error al actualizar el acreedor. Intenta nuevamente."));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Container>
      {(loading || saving) && (
        <Backdrop open={true} style={{ zIndex: 9999, color: "#fff" }}>
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      {proceso && initialAudiencia ? (
        <>
          <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
            <Grid size={6}>
              <Box
                sx={{
                  p: 2,
                  border: "1px solid #ddd",
                  borderRadius: "4px",
                  width: "100%",
                }}
              >
                <SuiTypography variant="h5" fontWeight="bold" sx={{ mb: 1 }}>
                  Deudor
                </SuiTypography>
                <InputLabel sx={{ alignItems: "center" }}>
                  <Checkbox
                    checked={asistencia.deudor?.asistio || false}
                    disabled={isDisabled()}
                    onChange={handleChange("deudor")}
                    color="primary"
                  />
                  {initialAudiencia.etapas[0]?.participantes?.deudor?.nombre_completo || ""}
                </InputLabel>
              </Box>
            </Grid>
            <Grid size={6}>
              <Box
                sx={{
                  p: 2,
                  border: "1px solid #ddd",
                  borderRadius: "4px",
                  width: "100%",
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                  <SuiTypography variant="h5" fontWeight="bold">
                    Apoderado Deudor
                  </SuiTypography>
                  <IconButton
                    color="primary"
                    onClick={() => setShowApoderadoModal(true)}
                    size="small"
                    disabled={isDisabled()}
                    sx={{ ml: 1 }}
                  >
                    <EditIcon />
                  </IconButton>
                  {asistencia.deudor_apoderado && (
                    <IconButton
                      color="error"
                      onClick={handleRemoveApoderadoDeudor}
                      size="small"
                      disabled={isDisabled()}
                      title="Quitar apoderado"
                    >
                      <ClearIcon />
                    </IconButton>
                  )}
                </Box>
                <InputLabel sx={{ alignItems: "center" }}>
                  <Checkbox
                    checked={asistencia.deudor_apoderado?.asistio || false}
                    disabled={isDisabled()}
                    onChange={handleChange("deudor_apoderado")}
                    color="primary"
                  />
                  {asistencia.deudor_apoderado?.nombre_completo || "Sin apoderado"}
                </InputLabel>
              </Box>
            </Grid>
          </Grid>
          <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }} sx={{ mt: 2 }}>
            <Grid size={12}>
              <Box
                sx={{
                  p: 2,
                  border: "1px solid #ddd",
                  borderRadius: "4px",
                  width: "100%",
                }}
              >
                <SuiTypography variant="h5" fontWeight="bold" sx={{ mb: 1 }}>
                  Acreedores y Apoderados
                </SuiTypography>
                <Table>
                  <TableBody>
                    {asistencia.acreedores?.map((acreedor, index) => (
                      <TableRow key={acreedor.id}>
                        <TableCell>
                          <InputLabel key={acreedor.id} sx={{ alignItems: "center" }}>
                            <IconButton
                              color="primary"
                              onClick={() => {
                                setSelectedAcreedorId(acreedor.id);
                                setShowAcreedorEditModal(true);
                              }}
                              size="small"
                              disabled={isDisabled()}
                              sx={{ ml: 1 }}
                            >
                              <EditIcon />
                            </IconButton>
                            <Checkbox
                              checked={acreedor.asistio || false}
                              disabled={isDisabled()}
                              onChange={handleChange("acreedores", index)}
                              color="primary"
                            />
                            {acreedor.nombre_completo}
                          </InputLabel>
                        </TableCell>
                        <TableCell>
                          {acreedor.apoderado ? (
                            <InputLabel sx={{ alignItems: "center" }}>
                              {acreedor.apoderado.nombre_completo}
                            </InputLabel>
                          ) : (
                            "Sin apoderado"
                          )}
                        </TableCell>
                        <TableCell>
                          <IconButton
                            color="primary"
                            onClick={() => {
                              setSelectedAcreedorId(acreedor.id);
                              setShowAcreedorApoderadoModal(true);
                            }}
                            size="small"
                            disabled={isDisabled()}
                            sx={{ ml: 1 }}
                          >
                            <EditIcon />
                          </IconButton>
                          {acreedor.apoderado && (
                            <IconButton
                              color="error"
                              onClick={() => handleRemoveAcreedorApoderado(acreedor.id)}
                              size="small"
                              disabled={isDisabled()}
                              title="Quitar apoderado"
                            >
                              <ClearIcon />
                            </IconButton>
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            </Grid>
          </Grid>
          {(roles.isAdmin || roles.isOperador) && (
            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
              <Grid size={6} sx={{ mt: 2, display: "flex", alignItems: "center", gap: 2 }}>
                <SuiButton
                  variant="gradient"
                  buttonColor="info"
                  onClick={handleSave}
                  disabled={isDisabled()}
                >
                  Guardar Etapa
                </SuiButton>
                <SuiTypography variant="caption" fontWeight="bold">
                  {!verificacion
                    ? "Cargando verificación..."
                    : initialAudiencia.estado === "SUSPENDIDA"
                    ? "- Audiencia suspendida (no modificable)"
                    : !verificacion.isQuorumCumplido && ordenActual > 1
                    ? "- No se puede avanzar: Quórum no completado"
                    : !verificacion.isEtapaAnteriorCumplida && ordenActual > 1
                    ? "- Complete la etapa anterior primero"
                    : verificacion.estadoActual === "CUMPLIDA"
                    ? "- Esta etapa ya fue completada"
                    : null}
                </SuiTypography>
              </Grid>
              <Grid
                size={6}
                sx={{
                  mt: 2,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                  gap: 2,
                }}
              >
                <SuiButton
                  variant="gradient"
                  buttonColor="dark"
                  onClick={handleAbrirEtapa}
                  disabled={isOpenEtapaDisabled()}
                >
                  Abrir Etapa
                </SuiButton>
              </Grid>
            </Grid>
          )}
        </>
      ) : (
        <Typography>No se encontraron datos de la audiencia</Typography>
      )}
      {showAcreedorEditModal && (
        <ModalAcreedor
          open={showAcreedorEditModal}
          onClose={() => setShowAcreedorEditModal(false)}
          acreedor={asistencia.acreedores.find((a) => a.id === selectedAcreedorId)}
          onSave={handleSaveAcreedor}
        />
      )}
      <SelectApoderado
        open={showApoderadoModal && !saving}
        onClose={() => !saving && setShowApoderadoModal(false)}
        onSelect={handleApoderadoSelect}
      />
      {showAcreedorApoderadoModal && (
        <ModalApoderado
          open={showAcreedorApoderadoModal}
          onClose={() => setShowAcreedorApoderadoModal(false)}
          onSelect={(apoderado) => handleAcreedorApoderadoSelect(selectedAcreedorId, apoderado)}
        />
      )}
    </Container>
  );
};

ContainerQuorum.propTypes = {
  proceso: PropTypes.object,
  audiencia: PropTypes.object,
  onAudienciaChange: PropTypes.func.isRequired,
};

export default ContainerQuorum;
